import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type RegisterLogoutMutationVariables = Types.Exact<{ [key: string]: never }>;

export type RegisterLogoutMutation = {
	__typename?: 'Mutation';
	registerLogout: { __typename?: 'RegisterPayload'; loginId: string };
};

export const RegisterLogoutDocument = gql`
	mutation RegisterLogout {
		registerLogout {
			loginId
		}
	}
`;
